import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

/* Bundled, not from a CDN — an offline runbook needs its icons and its type as
   much as it needs its text, and the depots block external CDNs anyway. */
import '@fontsource-variable/inter';
import '@tabler/icons-webfont/dist/tabler-icons.min.css';

import './styles/tokens.css';
import './styles/global.css';
import { App } from './App';

/* Theme before first paint, so a dark-mode launch does not flash white. */
const saved = localStorage.getItem('hird-blueprint-theme');
document.documentElement.dataset.theme =
  saved === 'light' || saved === 'dark'
    ? saved
    : window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
